export const AUTHORITY_TYPE = {
  superAdmin: "SUPER_ADMIN",
  empty: null,
} as const;
